/* prettier-ignore */

import { Injectable, inject } from '@angular/core';
import { DataChatService } from './dataChat.service';
import { AzurePrompt } from '../interface/azurePrompt.interface';
import { RequestService } from './request.service';
import { ScrollService } from './scrollContainer.service';
import { DebugService } from 'src/app/services/debug.service';
import { WebSocketService } from './webSocket.service';

@Injectable({ providedIn: 'root' })
export class SendMessageService {
  private webSocketService = inject(WebSocketService);
  private debugService = inject(DebugService);
  
  public dataChat = inject(DataChatService);
  public request = inject(RequestService);
  public scrollService = inject(ScrollService);

  async sendMessageWebSocket(userInput: string){
    this.webSocketService.sendWSChatBotData({output_type: 'text', content: userInput});

    this.dataChat.messages.update((prev) => [
      ...prev,
      {
        role: 'user',
        content: userInput,
        show: true,
      },
    ]);

    this.webSocketService.sendUserMessage(userInput);
    
    setTimeout(() => {
      this.scrollService.scrollToBottom();
    }, 0);
  }

  async sendMessage(message: string = '') {
    if (this.dataChat.isStreaming()) {
      this.dataChat.abortSignal().abort();
      this.dataChat.abortSignal.set(new AbortController());
      this.dataChat.isStreaming.set(false);
      this.dataChat.chatIsTyping.set(false);
      return;
    }

    this.dataChat.recommendedMessages.set([]);
    this.dataChat.toggleFormVisibility.set(false);
    this.dataChat.toggleSuccessMessage.set(false);
    this.dataChat.toggleErrorMessage.set(false);
    this.dataChat.canSaveChat.set(false);

    let userInput = message;
    if (message) {
      userInput = message;
      this.dataChat.recommendedMessages.set([]);
    }

    if (this.dataChat.isAzure()) {
      this.sendToAzure(userInput);
      return;
    }

    this.sendToChatbase(userInput);
  }

  sendToAzure(userInput: string) {
    this.debugService.info(this.dataChat.messagesForAzure(), '[SendMessageService] messagesForAzure');

    this.dataChat.messagesForAzure.update((prev) => [
      ...prev,
      { content: userInput, role: 'user' },
    ]);
    this.dataChat.messages.update((prev) => [
      ...prev,
      {
        role: 'user',
        content: userInput,
        show: true,
      },
    ]);
    setTimeout(() => {
      this.scrollService.scrollToBottom();
    }, 0);

    let question: AzurePrompt = {
      messages: this.dataChat.messagesForAzure(),
      chatbot_id: this.dataChat.id(),
      conversation_id: this.dataChat.token(),
      debug: this.dataChat.debug(),
      openai: this.dataChat.isOpenAi(),
      model3: this.dataChat.is35(),
    };

    this.request.getResponseFromAzure(question);
  }

  sendToChatbase(userInput: string) {
    this.dataChat.messagesForChatBase.update((prev) => [
      ...prev,
      { content: userInput, role: 'user' },
    ]);
    this.dataChat.messages.update((prev) => [
      ...prev,
      {
        role: 'user',
        content: userInput,
        show: true,
      },
    ]);

    setTimeout(() => {
      this.scrollService.scrollToBottom();
    }, 0);

    let question: any = {
      messages: this.dataChat.messagesForChatBase(),
      chatbotId: this.dataChat.chatbaseId(),
      stream: true,
      temperature: 0,
      model: 'gpt-4',
      conversationId: this.dataChat.token(),
    };

    this.request.getResponseFromChatbase(question);
  }
}
